import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/pnlValues')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/pnlValue' })
  },
})
